module.exports = __webpack_public_path__ + "static/media/ju6.bec9ca37.jpg";